import React from 'react';
import Countdown from 'react-countdown';
import './CountdownTimer.css';

const Completionist = () => <span>Time's up! Ready?</span>;

const CountdownTimer = () => {
  // Set the target date to September 18, 2026
  const targetDate = new Date('2026-09-18T00:00:00');

  const formatNumbers = (sec) => {
    return String(sec).padStart(2, '0');
  };

  return (
    <Countdown
      date={targetDate}
      renderer={({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
          return <Completionist />;
        } else {
          return (
            <span className="countdown-timer">
              Target launch in {days} days {formatNumbers(hours)}:{formatNumbers(minutes)}:{formatNumbers(seconds)}
            </span>
          );
        }
      }}
    />
  );
};

export default CountdownTimer;
